import { render, staticRenderFns } from "./OrderStart.vue?vue&type=template&id=8ce7d058&scoped=true"
import script from "./OrderStart.vue?vue&type=script&lang=js"
export * from "./OrderStart.vue?vue&type=script&lang=js"
import style0 from "./OrderStart.vue?vue&type=style&index=0&id=8ce7d058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce7d058",
  null
  
)

export default component.exports